import createUpdateFilesEvents from '/src/lib/custom/js/createupdatefilejson.js';
const FileUploadEvents = (function () {

    /* =========== Global Constants =========== */
    let folderUUID;
    let vendor;
    const FILE_UPLOAD_KEY = "fileData";
    const LINKED_IN_KEY = 'linkdInTxt';
    const TEXT_DATA = 'text_data';
    const LINKEDIN_FILENAME = 'linkedin.deflated.txt';
    const EXISTING_FILES_KEY = "browse_files"; // Correct definition
    let fileSortOrder = { fileName: 'asc', lastUpdated: 'asc' };
    const allowedTypes = [
        "application/msword",
        "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
        "application/pdf",
    ];
    const MAX_FILES = 5;
    let selectedFiles = [];
    let callback;
    let temporaryEventListeners = []; // Array for temporary listeners
    let persistentEventListeners = []; // Array for persistent listeners

    const eventListeners = []; // Tracks all event listeners

    const addListener = (selector, event, delegatedSelector, handler) => {
        if (delegatedSelector) {
            $(selector).on(event, delegatedSelector, handler); // Handle delegated events
        } else {
            $(selector).on(event, handler); // Handle direct binding
        }
        eventListeners.push({ selector, event, delegatedSelector, handler });
    };


    /* =========== Listener Management =========== */
    const addPersistentListener = (element, event, handler) => {
        if (element) {
            element.addEventListener(event, handler);
            persistentEventListeners.push({ element, event, handler });
        }
    };

    const addTemporaryListener = (element, event, handler) => {
        if (element) {
            element.addEventListener(event, handler);
            temporaryEventListeners.push({ element, event, handler });
        }
    };

    const removeFromTemporaryListeners = (element, event, handler) => {
        temporaryEventListeners = temporaryEventListeners.filter(
            (listener) =>
                listener.element !== element || listener.event !== event || listener.handler !== handler
        );
    };


    const removeTemporaryListeners = () => {
        temporaryEventListeners.forEach(({ element, event, handler }) => {
            element.removeEventListener(event, handler);
        });
        temporaryEventListeners = [];
    };

    const removeAllListeners = () => {
        persistentEventListeners.forEach(({ element, event, handler }) => {
            element.removeEventListener(event, handler);
        });
        persistentEventListeners = [];
        removeTemporaryListeners();
    };

    const init = (folderUUIDInit, vendorInit, callbackfromthisEditor, linkedInOpen = false) => {
        /* DOM Elements */
        folderUUID = folderUUIDInit;
        vendor = vendorInit;
        callback = callbackfromthisEditor;
        handleOpenModal(linkedInOpen);
    };


    const showTooltip = (icon, tooltip, modal) => {
        if (tooltip)
            tooltip.style.display = "block";
    };

    const hideTooltip = (tooltip) => {
        if (tooltip)
            tooltip.style.display = "none";
    };


    /* =========== Unload =========== */
    const unload = () => {
        const modal = document.getElementById("fileUploadModal");
        const preview = document.getElementById("preview");
        const uploadBtn = document.getElementById("uploadBtn");
        const fileInput = document.getElementById("fileInput");
        const infoIcon = document.getElementById("infoIcon");
        const infoIconExisting = document.getElementById("infoIconExisting");
        const tooltip = document.getElementById("fileUpload-tooltip");
        const tooltipExisting = document.getElementById("fileUpload-tooltip-Existing");


        if (modal) {
            modal.classList.add("fileUpload-hidden");
            modal.classList.remove("fileUpload-show");
        }

        selectedFiles = [];
        if (preview) preview.innerHTML = "";
        if (uploadBtn) uploadBtn.style.display = "none";
        if (fileInput) fileInput.value = "";
        folderUUID = null;
        vendor = null;
        callback = null;

        removeTemporaryListeners();
        removeAllListeners();
    };


    const unloadAll = () => {
        const modal = document.getElementById("fileUploadModal");
        const preview = document.getElementById("preview");
        const uploadBtn = document.getElementById("uploadBtn");
        const fileInput = document.getElementById("fileInput");
        const infoIcon = document.getElementById("infoIcon");
        const infoIconExisting = document.getElementById("infoIconExisting");
        const tooltip = document.getElementById("fileUpload-tooltip");
        const tooltipExisting = document.getElementById("fileUpload-tooltip-Existing");

        if (modal) {
            modal.classList.add("fileUpload-hidden");
            modal.classList.remove("fileUpload-show");
        }

        selectedFiles = [];
        if (preview) preview.innerHTML = "";
        if (uploadBtn) uploadBtn.style.display = "none";
        if (fileInput) fileInput.value = "";
        folderUUID = null;
        vendor = null;
        callback = null;

        removeTemporaryListeners();
        removeAllListeners();
        if (modal) removeAllChildrenAndStyles(modal);
    };
    /* =========== Event Handlers =========== */
    const handleOpenModal = async (linkedInOpen = false) => {
        showModalBackDrop(true);
        const modal = document.getElementById("fileUploadModal");
        const spinner = document.getElementById("modalSpinner");
        modal.classList.remove("fileUpload-hidden");
        spinner.style.display = "flex"; // Show the spinner
        const tab1 = document.getElementById("tab1");
        const tab2 = document.getElementById("tab2");
        const tab3 = document.getElementById("tab3");
        const content1 = document.getElementById("content1");
        const content2 = document.getElementById("content2");
        const content3 = document.getElementById("content3");
        const closeModalBtn = document.getElementById("closeModalBtn");
        const uploadFromComputerLink = document.getElementById("upload-from-computer");
        const seeHowtoLinkedIn = document.getElementById("see-howto-linkedIn");
        const refreshFilesBtn = document.getElementById("refreshFilesBtn");
        const refreshExistingFilesBtn = document.getElementById("refreshExistingFilesBtn");
        const selectFilesBtn = document.getElementById("selectFilesBtn");
        const fileInput = document.getElementById("fileInput");
        const uploadBtn = document.getElementById("uploadBtn");
        const infoIcon = document.getElementById("infoIcon");
        const infoIconExisting = document.getElementById("infoIconExisting");
        const tooltip = document.getElementById("fileUpload-tooltip");
        const tooltipExisting = document.getElementById("fileUpload-tooltip-Existing");
        const allTabs = [tab1, tab2, tab3];
        const allContents = [content1, content2, content3];
        const saveLinkedInButton = document.getElementById('saveLinkedInButton');
        const linkedinTextArea = document.getElementById('linkedinTextArea');
        const useThisFromText = document.getElementById('useThisFromText');



        modal.classList.remove("fileUpload-hidden");
        modal.classList.add("fileUpload-show");


        const storedFiles = JSON.parse(getLocalStorageItem(EXISTING_FILES_KEY)) || [];
        const fileUploadData = await fetchFilesFromAPI();
        const textData = JSON.parse(getLocalStorageItem(TEXT_DATA) || '[]');

        let linkedInUseThis = false;
        let useThisFileName = null;
        let useThisTextSelected = false;

        const fileWithUseThis = fileUploadData.find(f => f.useThisFile === "true");
        const storedWithUseThis = storedFiles.find(f => f.useThisFile === "true");

        if (fileWithUseThis) {
            useThisFileName = fileWithUseThis.fileName;
        } else if (storedWithUseThis) {
            useThisFileName = storedWithUseThis.fileName;
        } else if (textData.length === 1 && textData[0].useThisFile === "true") {
            linkedInUseThis = true;
            useThisTextSelected = true;
        }

        const headerContainer = document.getElementById("fileUpload-header-container");
        const headerText = document.querySelector(".fileUpload-modal-attachfile-text");

        if ((useThisFileName || useThisTextSelected) && headerContainer && headerText) {
            headerText.textContent = useThisFileName
                ? getI18nExt('info.fileselected', { fileName: useThisFileName })
                : getI18n('info.linkedInProfileSelected');
        } else {
            headerText.textContent = getI18n('info.nofileselected');
        }



        // Determine tab
        if (linkedInOpen || linkedInUseThis) {
            switchTab(tab3, allTabs, allContents);
            await loadLinkedInFromLocalStorage();
        } else if (fileWithUseThis || !storedWithUseThis) {
            switchTab(tab1, allTabs, allContents);
        } else {
            switchTab(tab2, allTabs, allContents);
        }





        // Attach temporary listeners for modal elements
        addTemporaryListener(content1, "dragover", handleDragOver);
        addTemporaryListener(content1, "dragleave", handleDragLeave);
        addTemporaryListener(content1, "drop", handleDropFiles);


        addTemporaryListener(tab1, "click", () => switchTab(tab1, allTabs, allContents));
        addTemporaryListener(tab2, "click", () => switchTab(tab2, allTabs, allContents));
        addTemporaryListener(tab3, "click", async () => {
            switchTab(tab3, allTabs, allContents);
            await loadLinkedInFromLocalStorage();

        });

        addTemporaryListener(closeModalBtn, "click", () => closeModal(modal));
        addTemporaryListener(refreshFilesBtn, "click", handleRefreshFiles);
        addTemporaryListener(refreshExistingFilesBtn, "click", handleRefreshFiles);
        addTemporaryListener(selectFilesBtn, "click", handleSelectFiles);
        addTemporaryListener(uploadFromComputerLink, "click", openUploadFromComputerTab);
        addTemporaryListener(seeHowtoLinkedIn, "click", seeHowtoLinkedInOpen);
        addTemporaryListener(fileInput, "change", handleFileInputChange);
        addTemporaryListener(uploadBtn, "click", handleUploadFiles);
        addTemporaryListener(infoIcon, "mouseenter", () => showTooltip(infoIcon, tooltip, modal));
        addTemporaryListener(infoIcon, "mouseleave", () => hideTooltip(tooltip));
        addTemporaryListener(infoIcon, "focus", () => showTooltip(infoIcon, tooltip, modal));
        addTemporaryListener(infoIcon, "blur", () => hideTooltip(tooltip));
        addTemporaryListener(linkedinTextArea, 'input', toggleSaveButton);

        // Attach listeners
        if (saveLinkedInButton && linkedinTextArea && useThisFromText) {
            addTemporaryListener(saveLinkedInButton, 'click', saveLinkedInToLocalStorage);
            addTemporaryListener(useThisFromText, 'change', saveLinkedInCheckBox);
        }

        addListener('th.fileupload-sortable', 'click', function () {
            const sortKey = $(this).data('sort');
            sortLoadedFilesTable(sortKey);
        });

        addListener('th.file-exiting-sortable', 'click', function () {
            const sortKey = $(this).data('sort');
            sortExistingFilesTable(sortKey);
        });



        addTemporaryListener(infoIconExisting, "mouseenter", () => showTooltip(infoIconExisting, tooltipExisting, modal));
        addTemporaryListener(infoIconExisting, "mouseleave", () => hideTooltip(tooltipExisting));
        addTemporaryListener(infoIconExisting, "focus", () => showTooltip(infoIconExisting, tooltipExisting, modal));
        addTemporaryListener(infoIconExisting, "blur", () => hideTooltip(tooltipExisting));


        try {
            spinner.style.display = "none"; // Hide the main spinner
            showSpinner();
            const fileList = await fetchFilesFromAPI();
            populateFileTable(fileList);
            if (storedFiles.length)
                populateExistingFilesTable();
            await loadLinkedInFromLocalStorage();
            toggleSaveButton();
        } catch (error) {
            console.error(getI18n("error.failedToLoadFiles"), error);
            showGrowlMessage(getI18n("error.failedToLoadFiles"), "danger");
        } finally {
            hideSpinner();
        }
    };


    const hasUseThisFileFlag = async () => {
        const storedFiles = JSON.parse(getLocalStorageItem(EXISTING_FILES_KEY)) || [];
        const textData = JSON.parse(getLocalStorageItem(TEXT_DATA) || '[]');
        const fileUploadData = await fetchFilesFromAPI();

        return (
            fileUploadData.some(f => f.useThisFile === 'true') ||
            storedFiles.some(f => f.useThisFile === 'true') ||
            (textData.length === 1 && textData[0].useThisFile === 'true')
        );
    };


    const updateHeaderFileName = async () => {
        const storedFiles = JSON.parse(getLocalStorageItem(EXISTING_FILES_KEY)) || [];
        const fileUploadData = await fetchFilesFromAPI();
        const textData = JSON.parse(getLocalStorageItem(TEXT_DATA) || '[]');

        let linkedInUseThis = false;
        let useThisFileName = null;
        let useThisTextSelected = false;
        let useThisFileFlag = false;

        const fileWithUseThis = fileUploadData.find(f => f.useThisFile === "true");
        const storedWithUseThis = storedFiles.find(f => f.useThisFile === "true");

        if (fileWithUseThis) {
            useThisFileName = fileWithUseThis.fileName;
            useThisFileFlag = true;
            linkedInUseThis = false;
        } else if (storedWithUseThis) {
            useThisFileName = storedWithUseThis.fileName;
            useThisFileFlag = true;
            linkedInUseThis = false;
        } else if (textData.length === 1 && textData[0].useThisFile === "true") {
            useThisFileFlag = false;
            linkedInUseThis = true;
            useThisTextSelected = true;
        }

        const headerContainer = document.getElementById("fileUpload-header-container");
        const headerText = document.querySelector(".fileUpload-modal-attachfile-text");

        if ((useThisFileName || useThisTextSelected) && headerContainer && headerText) {
            headerText.textContent = useThisFileName
                ? getI18nExt('info.fileselected', { fileName: useThisFileName })
                : getI18n('info.linkedInProfileSelected');
        } else {
            headerText.textContent = getI18n('info.nothingselectedbase');
        }
        updateBadgeIcons(useThisFileFlag, linkedInUseThis, true);
    };

    const toggleSaveButton = () => {
        const isTextEmpty = !linkedinTextArea.value.trim();
        //saveLinkedInButton.disabled = isTextEmpty;
        useThisFromText.disabled = isTextEmpty;

        const useThisFromHeading = document.getElementById('useThisFromHeading');
        if (useThisFromHeading) {
            if (isTextEmpty) {
                useThisFromHeading.classList.add('disabled-label');
            } else {
                useThisFromHeading.classList.remove('disabled-label');
            }
        }
    };

    // Utility to save text and checkbox status
    const saveLinkedInToLocalStorage = () => {
        const rawText = linkedinTextArea?.value.trim();
        if (rawText) {
            uploadLinkedInProfileText(linkedinTextArea, useThisFromText, saveLinkedInButton);
        } else {
            if (getLocalStorageItem(TEXT_DATA)) {
                deleteLinkedInFile(useThisFromText, saveLinkedInButton);
            } else {
                showGrowlMessage(getI18n("info.nothingToDo"), "info");
            }
        }
    };

    const saveLinkedInCheckBox = () => {
        const isChecked = useThisFromText.checked;
        if (getLocalStorageItem(LINKED_IN_KEY))
            updateFileUsage(LINKEDIN_FILENAME, isChecked, false, true);
    };


    const loadLinkedInFromLocalStorage = async () => {

        showSpinner();
        try {
            const compressed = getLocalStorageItem(LINKED_IN_KEY);
            // Check if we already have compressed LinkedIn content
            if (compressed) {
                try {
                    const decoded = decodeAndInflate(compressed);
                    linkedinTextArea.value = decoded;

                    // Still get the useThisFile flag from TEXT_DATA
                    const textDataRaw = getLocalStorageItem(TEXT_DATA);
                    if (textDataRaw) {
                        try {
                            const data = JSON.parse(textDataRaw);
                            if (Array.isArray(data) && data.length === 1) {
                                const { useThisFile } = data[0];
                                useThisFromText.checked = useThisFile === "true";
                            }
                        } catch (e) {
                            console.error('Error parsing TEXT_DATA while setting useThisFromText:', e);
                        }
                    }
                } catch (err) {
                    console.error('Error decoding LINKED_IN_KEY:', err);
                } finally {
                    hideSpinner();
                }

                return;
            }

            // Fallback to loading from TEXT_DATA and fetch the file
            const textDataRaw = getLocalStorageItem(TEXT_DATA);
            if (!textDataRaw) {
                hideSpinner();
                return;
            }

            try {
                const data = JSON.parse(textDataRaw);
                if (Array.isArray(data) && data.length === 1) {
                    const { filePath, useThisFile } = data[0];

                    if (filePath && typeof filePath === 'string') {
                        try {
                            //console.log ('File Path is:', filePath);
                            //logClouldFrontCookies();
                            const response = await fetch(filePath);
                            if (!response.ok) throw new Error(`Failed to fetch ${filePath}: ${response.statusText}`);
                            const base64Text = await response.text();
                            //console.log ('base64Text is: ', base64Text);
                            const inflatedText = decodeAndInflate(base64Text);


                            linkedinTextArea.value = inflatedText;
                            setLocalStorageItem(LINKED_IN_KEY, base64Text);
                        } catch (e) {
                            console.error('Error fetching or decoding LinkedIn .txt file:', e);
                        }
                    }

                    useThisFromText.checked = useThisFile === "true";
                }
            } catch (error) {
                console.error('Error loading LinkedIn data from TEXT_DATA:', error);
            }
            finally {
                hideSpinner();
            }
        } catch (error) {
            console.error("Error loading LinkedIn data:", error);
        } finally {
            hideSpinner();
        }
    };


    const showSpinner = async () => {
        $('#fileUpload-loadingSpinner').show();
        $('#existing-fileUpload-loadingSpinner').show();
        $('#lnkdIn-loadingSpinner').show();
    }

    const hideSpinner = async () => {
        $('#fileUpload-loadingSpinner').hide();
        $('#existing-fileUpload-loadingSpinner').hide();
        $('#lnkdIn-loadingSpinner').hide();
    }

    const handleRefreshFiles = async () => {
        try {
            showSpinner();
            const fileList = await fetchFilesFromAPI(true);
            setRefreshedCookie();
            populateFileTable(fileList);
            const tab2 = document.getElementById("tab2");
            const noExistingFiles = document.getElementById("no-existing-files");
            const storedFiles = JSON.parse(localStorage.getItem(EXISTING_FILES_KEY)) || [];
            if (!storedFiles.length) {
                existingFilesTableContainer.style.display = "none";
                noExistingFiles.style.display = "flex";
            } else {
                noExistingFiles.style.display = "none";
                existingFilesHeading.style.display = "block";
                populateExistingFilesTable();
            }
            showGrowlMessage(getI18nExt('files.refreshedSuccessfully'), "success");
        } catch (error) {
            console.error(getI18nExt('error.refreshingFiles'), error);
            showGrowlMessage(getI18nExt('error.failedToRefresh'), "danger");
        } finally {
            hideSpinner();
        }
    };

    const handleSelectFiles = async () => {
        try {
            const storedList = await fetchFilesFromAPI();

            if (storedList.length >= MAX_FILES) {
                showGrowlMessage(getI18nExt('files.maxLimitExceeded', { max: MAX_FILES }), "danger");
                return;
            }

            const fileInput = document.getElementById("fileInput");
            fileInput.click();
        } catch (error) {
            console.error(getI18nExt('error.checkingFileLimit'), error);
            showGrowlMessage(getI18nExt('error.failedToCheckLimit'), "danger");
        }
    };

    const sortLoadedFilesTable = async (sortKey) => {
        const loadedFileData = await fetchFilesFromAPI();
        if (!fileSortOrder[sortKey]) {
            fileSortOrder[sortKey] = 'asc';
        } else if (fileSortOrder[sortKey] === 'asc') {
            fileSortOrder[sortKey] = 'desc';
        } else {
            delete fileSortOrder[sortKey];
        }

        const order = fileSortOrder[sortKey];
        if (order) {
            loadedFileData.sort((a, b) => {
                let aValue = a[sortKey];
                let bValue = b[sortKey];
                if (sortKey === 'lastUpdated') {
                    aValue = new Date(aValue);
                    bValue = new Date(bValue);
                }
                return aValue < bValue ? (order === 'asc' ? -1 : 1) : (aValue > bValue ? (order === 'asc' ? 1 : -1) : 0);
            });
        } else {
            loadedFileData.sort((a, b) => loadedFileData.indexOf(a) - loadedFileData.indexOf(b)); // Default order
        }

        populateFileTable(loadedFileData); // Re-render the table
    };


    const sortExistingFilesTable = (sortKey) => {
        const existingFileData = JSON.parse(localStorage.getItem(EXISTING_FILES_KEY));
        if (!fileSortOrder[sortKey]) {
            fileSortOrder[sortKey] = 'asc';
        } else if (fileSortOrder[sortKey] === 'asc') {
            fileSortOrder[sortKey] = 'desc';
        } else {
            delete fileSortOrder[sortKey];
        }

        const order = fileSortOrder[sortKey];
        if (order) {
            existingFileData.sort((a, b) => {
                let aValue = a[sortKey];
                let bValue = b[sortKey];
                if (sortKey === 'lastUpdated') {
                    aValue = new Date(aValue);
                    bValue = new Date(bValue);
                }
                return aValue < bValue ? (order === 'asc' ? -1 : 1) : (aValue > bValue ? (order === 'asc' ? 1 : -1) : 0);
            });
        } else {
            existingFileData.sort((a, b) => existingFileData.indexOf(a) - existingFileData.indexOf(b)); // Default order
        }

        populateExistingFilesTable(existingFileData); // Re-render the table
    };




    const handleFileInputChange = async () => {
        try {
            const storedList = await fetchFilesFromAPI();
            const fileInput = document.getElementById("fileInput");
            addFiles(fileInput.files, storedList);
        } catch (error) {
            console.error(getI18nExt("error.checkingFileLimit"), error);
            showGrowlMessage(getI18nExt("error.failedToCheckLimit"), "danger");
        }
    };

    const handleUploadFiles = () => {
        if (!selectedFiles.length) {
            showGrowlMessage(getI18nExt("error.noFilesSelected"), "info");
            return;
        }

        uploadUserFiles(selectedFiles);
        selectedFiles = [];
        const preview = document.getElementById("preview");
        preview.innerHTML = "";
        const uploadBtn = document.getElementById("uploadBtn");
        uploadBtn.style.display = "none";
    };


    const openUploadFromComputerTab = () => {
        switchTab(tab1, [tab1, tab2, tab3], [content1, content2, content3]);
    };


    const seeHowtoLinkedInOpen = (event) => {
        const lang = getLanguage();
        staticModalModule.init(`/dist/custom/js/data/html/senior-marketing-profession/linkedin-${lang}.html`, "staticModalContainer", event);
    };


    const handleDragOver = (e) => {
        e.preventDefault();
        e.stopPropagation();
        const content1 = document.getElementById("content1");
        content1.classList.add("fileUpload-dropZone-active");
    };


    const handleDragLeave = (e) => {
        e.preventDefault();
        e.stopPropagation();
        const content1 = document.getElementById("content1");
        content1.classList.remove("fileUpload-dropZone-active");
    };


    const handleDropFiles = async (e) => {
        // Prevent the browser's default behavior
        e.preventDefault();
        e.stopPropagation();

        const content1 = document.getElementById("content1");
        content1.classList.remove("fileUpload-dropZone-active");

        const droppedFiles = e.dataTransfer.files;

        if (!droppedFiles || droppedFiles.length === 0) {
            console.error(getI18nExt("error.noFilesDropped"));
            return;
        }

        try {
            const storedList = await fetchFilesFromAPI();
            const totalFiles = storedList.length + droppedFiles.length;

            if (totalFiles > MAX_FILES) {
                const excessCount = totalFiles - MAX_FILES;
                showGrowlMessage(
                    getI18nExt("files.limitExceeded", { limit: MAX_FILES, excess: excessCount }),
                    "danger"
                );
                return;
            }

            addFiles(droppedFiles, storedList);
        } catch (error) {
            console.error(getI18nExt("error.checkingFileLimit"), error);
            showGrowlMessage(getI18nExt("error.failedToCheckLimit"), "danger");
        }
    };


    /* =========== File Upload Integration =========== */
    const uploadUserFiles = async (files) => {
        showSpinner();
        const hostname = window.location.hostname;
        const locale = navigator.language || "en-US";
        const type = "upload";

        try {

            const isFirstUpload = !hasUseThisFileFlag();

            const formData = new FormData();
            files.forEach((file) => formData.append("files", file));

            const requestData = JSON.stringify({
                folderUUID,
                vendor,
                hostname,
                locale,
                type,
                useThisFile: isFirstUpload ? "true" : "false",
            });

            formData.append("requestData", new Blob([requestData], { type: "application/json" }));

            const response = await fetch(getApiUrl('uploaduserfiles', 'loginapi'), {
                method: "POST",
                headers: {
                    "X-CSRF-Token": "test-csrf-token",
                },
                body: formData,
            });

            if (!response.ok) {
                if (response.status === 413) {
                    throw new Error(getI18nExt("error.fileTooLarge"));
                } else {
                    throw new Error(getI18nExt("error.uploadFailed", { statusText: response.statusText }));
                }
            }

            const result = await response.json();

            result.forEach((fileResult) => {
                if (fileResult.success) {
                    const filePath = fileResult.filePath || "<unknown>";
                    const fileName = filePath.split("/").pop();
                    const lastUpdated = fileResult.lastUpdated || new Date().toISOString();
                    const useThisFile = fileResult.useThisFile === "true" ? "true" : "false";
                    const type = fileResult.type;

                    if (useThisFile === "true") {
                        const modal = document.getElementById("fileUploadModal");
                        const allCheckboxes = modal.querySelectorAll("input[type='checkbox']");
                        allCheckboxes.forEach((cb) => (cb.checked = false));

                    }

                    addToFileUploadData({ filePath, fileName, lastUpdated, useThisFile, type });
                    addTableRow(filePath, fileName, lastUpdated, useThisFile, false, true, true);
                } else {
                    showGrowlMessage(
                        getI18nExt("error.uploadSingleFileFailed", { message: fileResult.message }),
                        "danger"
                    );
                }
                updateHeaderFileName();
            });
        } catch (error) {
            console.error(getI18nExt("error.fileUploadFailed"), error);
            showGrowlMessage(error.message.includes(getI18nExt("error.fileTooLarge")) ? error.message : getI18nExt("error.genericUploadFailure"), "danger");
        } finally {
            hideSpinner();
        }
    }

    const fetchFilesFromAPI = async (force = false) => {
        if (force)
            await callback(folderUUID, vendor, true);

        const fileUploadData = getLocalStorageItem(FILE_UPLOAD_KEY);
        if (fileUploadData) {
            return JSON.parse(fileUploadData);
        }
        else
            return [];
    };

    const populateFileTable = (fileList) => {
        const loadedFilesTable = document.getElementById("loadedFilesTable").querySelector("tbody");
        const loadedFilesHeading = document.getElementById("loadedFilesHeading");
        const loadedFilesTableContainer = document.getElementById("loadedFilesTableContainer");
        const refreshFilesBtn = document.getElementById("refreshFilesBtn");

        loadedFilesTable.innerHTML = ""; // Clear the existing rows

        if (!fileList.length) {
            loadedFilesHeading.style.display = "none";
            loadedFilesTableContainer.style.display = "none";
            refreshFilesBtn.style.display = "none";
            return;
        }

        fileList.forEach((file) => {
            const fileName = file.filePath.split("/").pop();
            const lastUpdated = file.lastUpdated || new Date().toISOString();
            const useThisFile = file.useThisFile || "false";
            addTableRow(file.filePath, fileName, lastUpdated, useThisFile, false, true);
        });

        loadedFilesHeading.style.display = "block";
        loadedFilesTableContainer.style.display = "block";
        refreshFilesBtn.style.display = getCookie('refreshed') ? "none" : "inline-block";

    };

    const switchTab = (activeTab, allTabs, allContents) => {
        if (!activeTab || !Array.isArray(allTabs) || !Array.isArray(allContents)) {
            console.error(getI18nExt('error.invalidParametersSwitchTab'));
            return;
        }

        allTabs.forEach(tab => tab.classList.remove("fileUpload-modal-tab-active"));
        allContents.forEach(content => content.classList.add("fileUpload-hiddenContent"));

        activeTab.classList.add("fileUpload-modal-tab-active");
        const index = allTabs.indexOf(activeTab);
        if (index >= 0 && allContents[index]) {
            allContents[index].classList.remove("fileUpload-hiddenContent");
        }
    };



    const addTableRow = (filePath, fileName, lastUpdated, useThisFile, prepend = false, fromComputer = true, newFileUploaded = false) => {
        const loadedFilesTable = document.getElementById("loadedFilesTable").querySelector("tbody");
        const tr = document.createElement("tr");

        const tdRemove = document.createElement("td");
        tdRemove.classList.add("colRemove");
        const removeBtn = document.createElement("button");
        removeBtn.classList.add("fileUpload-tableRemoveBtn");
        removeBtn.textContent = "x";
        const removeHandler = () => {
            removeLoadedFile(fileName, tr, checkboxHandler, fromComputer);
        };
        addTemporaryListener(removeBtn, "click", removeHandler);
        tdRemove.appendChild(removeBtn);
        tr.appendChild(tdRemove);

        const tdName = document.createElement("td");
        tdName.classList.add("colName");
        const downloadLink = document.createElement("a");
        downloadLink.href = filePath;
        downloadLink.textContent = fileName;
        downloadLink.target = "_blank";
        downloadLink.rel = "noopener noreferrer";
        tdName.appendChild(downloadLink);
        tr.appendChild(tdName);

        const tdLastUpdated = document.createElement("td");
        tdLastUpdated.classList.add("colLastUpdated");
        tdLastUpdated.textContent = new Date(lastUpdated).toLocaleString();
        tr.appendChild(tdLastUpdated);

        const tdUse = document.createElement("td");
        tdUse.classList.add("colUse", "fileUpload-radioCell");
        const checkbox = document.createElement("input");
        checkbox.type = "checkbox";
        checkbox.name = "useFile";
        checkbox.classList.add("custom-checkbox");
        checkbox.checked = useThisFile === "true";

        const checkboxHandler = () => {
            if (checkbox.checked) {
                const allCheckboxes = loadedFilesTable.querySelectorAll("input[type='checkbox']");
                allCheckboxes.forEach((cb) => {
                    if (cb !== checkbox) cb.checked = false;
                });
                updateFileUsage(fileName, true, fromComputer);
            } else {
                updateFileUsage(fileName, false, fromComputer);
            }
        };

        addTemporaryListener(checkbox, "change", checkboxHandler);

        const label = document.createElement("span");
        label.classList.add("mobileLabel");
        label.textContent = getI18nExt("useThisFile");

        tdUse.appendChild(checkbox);
        tdUse.appendChild(document.createTextNode(" "));
        tdUse.appendChild(label);
        tr.appendChild(tdUse);

        if (prepend && loadedFilesTable.firstChild) {
            loadedFilesTable.insertBefore(tr, loadedFilesTable.firstChild);
        } else {
            loadedFilesTable.appendChild(tr);
        }

        if (newFileUploaded) {
            // Add visual indication to each <td>
            const tds = tr.querySelectorAll("td");
            tds.forEach(td => {
                td.style.backgroundColor = "var(--growl-success-bg)"; // Set temporary background color
            });

            setCustomTimeout(() => {
                tds.forEach(td => {
                    td.style.transition = "background-color 1s ease";
                    td.style.backgroundColor = ""; // Revert to default background color
                });
            }, 2000); // 2 seconds
        }



        ensureTableVisibility();
    };


    const addFiles = (files, storedList) => {
        const newFiles = Array.from(files);

        if (storedList.length + newFiles.length > MAX_FILES) {
            showGrowlMessage(getI18nExt('files.maxAllowed', { max: MAX_FILES }), "danger");
            return;
        }

        newFiles.forEach((file) => {
            if (!allowedTypes.includes(file.type)) {
                showGrowlMessage(getI18nExt('error.invalidFileType', { fileName: file.name }), "danger");
                return;
            }

            const fullPath = file.webkitRelativePath || file.name;
            const duplicateSession = selectedFiles.some(
                (f) => (f.webkitRelativePath || f.name) === fullPath
            );
            if (duplicateSession) {
                showGrowlMessage(getI18nExt('error.fileAlreadyInSession', { filePath: fullPath }), "danger");
                return;
            }

            const duplicateStored = storedList.some((storedFile) => {
                const storedFileName = storedFile.filePath.split("/").pop();
                return storedFileName === fullPath;
            });
            if (duplicateStored) {
                showGrowlMessage(getI18nExt('error.fileAlreadyInAccount', { filePath: fullPath }), "danger");
                return;
            }

            selectedFiles.push(file);
        });

        updatePreview();
    };

    const updatePreview = () => {
        const preview = document.getElementById("preview");
        const uploadBtn = document.getElementById("uploadBtn");

        preview.innerHTML = "";
        uploadBtn.style.display = selectedFiles.length ? "inline-block" : "none";

        selectedFiles.forEach((file, index) => {
            const fileItem = document.createElement("div");
            fileItem.classList.add("fileUpload-fileItem");

            const removeBtn = document.createElement("button");
            removeBtn.classList.add("fileUpload-removeBtn");
            removeBtn.textContent = "x";
            removeBtn.addEventListener("click", () => {
                selectedFiles.splice(index, 1);
                updatePreview();
            });

            let iconSVG = "";
            if (file.type === "application/pdf") {
                iconSVG = `<svg class="fileUpload-icon"><use xlink:href="#icon-pdf"></use></svg>`;
            } else {
                iconSVG = `<svg class="fileUpload-icon"><use xlink:href="#icon-word"></use></svg>`;
            }

            const fileURL = URL.createObjectURL(file);
            const fileLink = document.createElement("a");
            fileLink.classList.add("fileUpload-fileLink");
            fileLink.href = fileURL;
            fileLink.target = "_blank";
            fileLink.rel = "noopener noreferrer";
            fileLink.innerHTML = iconSVG + file.name;

            fileItem.appendChild(removeBtn);
            fileItem.appendChild(fileLink);
            preview.appendChild(fileItem);
        });
    };

    const ensureTableVisibility = () => {
        const loadedFilesTable = document.getElementById("loadedFilesTable").querySelector("tbody");
        const loadedFilesHeading = document.getElementById("loadedFilesHeading");
        const loadedFilesTableContainer = document.getElementById("loadedFilesTableContainer");
        const refreshFilesBtn = document.getElementById("refreshFilesBtn");

        const hasRows = !!loadedFilesTable.querySelector("tr");
        loadedFilesHeading.style.display = hasRows ? "block" : "none";
        loadedFilesTableContainer.style.display = hasRows ? "block" : "none";

        refreshFilesBtn.style.display = getCookie('refreshed') ? 'none' : (hasRows ? 'inline-block' : 'none');

    };

    const updateFileUsage = async (selectedFileName, isChecked, fromComputer, linkedIn = false) => {
        try {
            showSpinner();

            const fileUploadData = await fetchFilesFromAPI();
            const storedFiles = JSON.parse(localStorage.getItem(EXISTING_FILES_KEY)) || [];
            const textData = JSON.parse(getLocalStorageItem(TEXT_DATA) || '[]');

            const filesToUnset = [
                ...fileUploadData.filter(file => file.useThisFile === "true"),
                ...storedFiles.filter(file => file.useThisFile === "true"),
                ...textData.filter(file => file.useThisFile === "true")
            ];

            const unsetPromises = filesToUnset.map((file) => {
                const endpoint = (() => {
                    if (file.type === 'linkedin' || file.type === 'upload') {
                        return getApiUrl('updateFileUsage', 'loginapi');
                    } else {
                        return getApiUrl('updateFileUsageResumeOrCL', 'loginapi');
                    }
                })();


                return fetch(endpoint, {
                    method: "POST",
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify({
                        folderUUID,
                        vendor,
                        fileName: file.fileName,
                        useThisFile: "false",
                    }),
                }).then(response => {
                    if (!response.ok) {
                        throw new Error(`Failed to unset file: ${file.fileName}, status: ${response.status}`);
                    }
                });
            });

            await Promise.all(unsetPromises);

            filesToUnset.forEach((file) => {
                if (fileUploadData.some(f => f.fileName === file.fileName)) {
                    updateFileUploadData(file.fileName, { useThisFile: "false" });
                } else if (storedFiles.some(f => f.fileName === file.fileName)) {
                    updateStoredData(file.fileName, { useThisFile: "false" });
                } else if (file.type === 'linkedin' || linkedIn) {
                    updateLinkedInUploadData(file.fileName, { useThisFile: "false" });
                }
            });

            if (isChecked) {
                const endpoint = fromComputer || linkedIn
                    ? getApiUrl('updateFileUsage', 'loginapi')
                    : getApiUrl('updateFileUsageResumeOrCL', 'loginapi');

                const setResponse = await fetch(endpoint, {
                    method: "POST",
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify({
                        folderUUID,
                        vendor,
                        fileName: selectedFileName,
                        useThisFile: "true",
                    }),
                });

                if (!setResponse.ok) {
                    throw new Error(`Failed to set file: ${selectedFileName}, status: ${setResponse.status}`);
                }

                if (fromComputer) {
                    updateFileUploadData(selectedFileName, { useThisFile: "true" });
                } else if (linkedIn) {
                    updateLinkedInUploadData(selectedFileName, { useThisFile: "true" });
                } else {
                    updateStoredData(selectedFileName, { useThisFile: "true" });
                }

                refreshTableUI();
                const headerText = document.querySelector(".fileUpload-modal-attachfile-text");
                if (selectedFileName === LINKEDIN_FILENAME) {
                    if (headerText) {
                        updateHeaderFileName();
                        headerText.textContent = "LinkedIn profile text selected";
                    }
                    showGrowlMessage(getI18n("success.linkedInUsageUpdated"), "success");
                } else {
                    if (headerText) {
                        updateHeaderFileName();
                        headerText.textContent = `File selected: ${selectedFileName}`;
                    }
                    showGrowlMessage(getI18nExt("success.fileUsageUpdated", { fileName: selectedFileName }), "success");
                }
            } else {
                if (selectedFileName === LINKEDIN_FILENAME) {
                    updateHeaderFileName();
                    showGrowlMessage(getI18n("info.linkedInUsageUnset"), "info");
                } else {
                    updateHeaderFileName();
                    showGrowlMessage(getI18nExt("info.fileUsageUnset", { fileName: selectedFileName }), "info");
                }
            }

        } catch (error) {
            refreshTableUI();
            const action = isChecked ? getI18nExt("action.set") : getI18nExt("action.unset");
            if (selectedFileName === LINKEDIN_FILENAME) {
                showGrowlMessage(getI18nExt("error.linkedInFileUsageFailed", { action, fileName: selectedFileName }), "danger");
            } else {
                showGrowlMessage(getI18nExt("error.fileUsageFailed", { action, fileName: selectedFileName }), "danger");
            }
        } finally {
            hideSpinner();
        }
    };







    const showGrowlMessage = (message, type = "danger") => {
        const growlContainer = document.getElementById("growlContainer");

        const alertDiv = document.createElement("div");
        alertDiv.classList.add("growlAlert", `growlAlert-${type}`);
        alertDiv.textContent = message;

        const closeBtn = document.createElement("button");
        closeBtn.classList.add("growlAlert-closeBtn");
        closeBtn.innerHTML = "&times;";
        closeBtn.addEventListener("click", () => fadeOutAndRemove(alertDiv));
        alertDiv.appendChild(closeBtn);

        growlContainer.appendChild(alertDiv);

        setCustomTimeout(() => fadeOutAndRemove(alertDiv), 2000);
    };

    const fadeOutAndRemove = (elem) => {
        elem.style.opacity = "0";
        setCustomTimeout(() => {
            if (elem.parentNode) {
                elem.parentNode.removeChild(elem);
            }
        }, 400);
    };

    const deleteLinkedInFile = (useThisFromText, saveLinkedInButton) => {
        saveLinkedInButton.disabled = true;
        showSpinner();

        const requestData = {
            folderUUID,
            vendor,
            fileNames: [LINKEDIN_FILENAME]
        };

        fetch(getApiUrl('deleteFiles', 'loginapi'), {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify(requestData)
        })
            .then((response) => {
                if (!response.ok) {
                    throw new Error(getI18nExt("error.deleteFileFailed"));
                }

                removeFromLinkedInUploadData();
                return response.json();
            })
            .then((data) => {
                if (data.status === "success") {
                    showGrowlMessage(getI18n("info.linkedInContentSaved"), "success");
                    deleteLocalStorageItem(LINKED_IN_KEY);
                    toggleSaveButton();
                    if (useThisFromText && useThisFromText.checked) {
                        useThisFromText.checked = false;
                    }
                } else {
                    showGrowlMessage(
                        getI18n("error.linkedInContentSavedFailed"),
                        "danger"
                    );
                }
            })
            .catch((error) => {
                console.error(getI18n("error.linkedInContentSavedFailed"), error);
                showGrowlMessage(getI18n("error.linkedInContentSavedFailed"), "danger");
            })
            .finally(() => {
                hideSpinner();
                updateHeaderFileName();
                saveLinkedInButton.disabled = false;
            });
    };


    const removeLoadedFile = (fileName, row, checkboxHandler, fromComputer) => {
        console.log(getI18nExt("log.removeLoadedFile"));
        Swal.fire({
            title: getI18nExt("modal.title.confirmDelete"),
            html: getI18nExt("modal.html.confirmDelete", { fileName }),
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: getI18nExt("modal.button.confirmDelete"),
            cancelButtonText: getI18nExt("modal.button.cancel"),
        }).then((result) => {
            if (result.isConfirmed) {
                showSpinner();
                const requestData = {
                    folderUUID,
                    vendor,
                    fileNames: [fileName],
                };

                // Determine the endpoint based on fromComputer
                const endpoint = fromComputer
                    ? getApiUrl('deleteFiles', 'loginapi')
                    : getApiUrl('deleteObjects', 'loginapi');

                fetch(endpoint, {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify(requestData),
                })
                    .then((response) => {
                        if (!response.ok) {
                            throw new Error(getI18nExt("error.deleteFileFailed"));
                        }
                        // Remove from session or local storage depending on source
                        if (fromComputer) {
                            removeFromFileUploadData(fileName);
                        } else {
                            createUpdateFilesEvents.deleteFile(fileName);
                        }
                        return response.json();
                    })
                    .then((data) => {
                        if (data.status === "success") {
                            // Remove event listeners
                            const checkbox = row.querySelector("input[type='checkbox']");
                            if (checkbox) {
                                checkbox.removeEventListener("change", checkboxHandler);
                                removeFromTemporaryListeners(checkbox, "change", checkboxHandler);
                            }
                            row.remove();
                            ensureTableVisibility();
                            showGrowlMessage(getI18nExt("success.fileDeleted", { fileName }), "success");
                        } else {
                            showGrowlMessage(
                                getI18nExt("error.fileDeleteFailed", { fileName, message: data.message }),
                                "danger"
                            );
                        }
                    })
                    .catch((error) => {
                        console.error(getI18nExt("error.fileDeleteFailedGeneric"), error);
                        showGrowlMessage(getI18nExt("error.fileDeleteFailedGeneric"), "danger");
                    })
                    .finally(() => {
                        hideSpinner();
                        updateHeaderFileName();
                    });

            }
        });
    };



    const closeModal = (modal) => {
        hideModalBackDrop();

        // Hide modal
        modal.classList.remove('fileUpload-show');
        modal.classList.add('fileUpload-hidden');

        // // Retrieve files from localStorage
        // const storedFiles = JSON.parse(localStorage.getItem(EXISTING_FILES_KEY)) || [];
        // const sessionFiles = JSON.parse(localStorage.getItem(FILE_UPLOAD_KEY)) || [];
        // const textData = JSON.parse(getLocalStorageItem(TEXT_DATA) || '[]');

        // // Determine if any file has the useThisFile flag set to true
        // const useThisFileFlag =
        //     storedFiles.some(file => file.useThisFile === "true") ||
        //     sessionFiles.some(file => file.useThisFile === "true");

        // let linkedInUseThis=false;
        // if (textData.length === 1 && textData[0].useThisFile === "true") {
        //     linkedInUseThis = true;
        // }
        // updateBadgeIcons(useThisFileFlag, linkedInUseThis, true);
        unload();
    };

    const updateBadgeIcons = (useThisFileFlag, linkedInUseThis, updateLocalStorage) => {
        // Toggle icons based on the flag
        const attachDefaultIcon = document.getElementById("icon-attach-default");
        const clipWithBadgeIcon = document.getElementById("icon-clip-with-badge");
        const linkedInDefaultIcon = document.getElementById("icon-linkedin-default");
        const linkedInithBadgeIcon = document.getElementById("icon-linkedin-with-badge");

        if (useThisFileFlag) {
            attachDefaultIcon && (attachDefaultIcon.style.display = "none");
            clipWithBadgeIcon && (clipWithBadgeIcon.style.display = "inline");
            updateLocalStorage && setLocalStorageItem("useThisFile", "true");
            updateLocalStorage && deleteLocalStorageItem("linkedInUseThis");
        } else {
            attachDefaultIcon && (attachDefaultIcon.style.display = "inline");
            clipWithBadgeIcon && (clipWithBadgeIcon.style.display = "none");
            updateLocalStorage && deleteLocalStorageItem("useThisFile");
        }

        if (linkedInUseThis) {
            linkedInDefaultIcon && (linkedInDefaultIcon.style.display = "none");
            linkedInithBadgeIcon && (linkedInithBadgeIcon.style.display = "inline");
            updateLocalStorage && setLocalStorageItem("linkedInUseThis", "true");
            updateLocalStorage && deleteLocalStorageItem("useThisFile");
        } else {
            linkedInDefaultIcon && (linkedInDefaultIcon.style.display = "inline");
            linkedInithBadgeIcon && (linkedInithBadgeIcon.style.display = "none");
            updateLocalStorage && deleteLocalStorageItem("linkedInUseThis");
        }

    };


    const updateFileUploadData = (fileName, updates) => {
        const fileUploadData = JSON.parse(getLocalStorageItem(FILE_UPLOAD_KEY)) || [];
        const updatedData = fileUploadData.map((file) =>
            file.fileName === fileName ? { ...file, ...updates } : file
        );
        setLocalStorageItem(FILE_UPLOAD_KEY, JSON.stringify(updatedData));
    };

    const addToFileUploadData = (newFile) => {
        const fileUploadData = JSON.parse(getLocalStorageItem(FILE_UPLOAD_KEY)) || [];
        fileUploadData.push(newFile);
        setLocalStorageItem(FILE_UPLOAD_KEY, JSON.stringify(fileUploadData));
    };

    const removeFromFileUploadData = (fileName) => {
        const fileUploadData = JSON.parse(getLocalStorageItem(FILE_UPLOAD_KEY)) || [];
        const updatedData = fileUploadData.filter((file) => file.fileName !== fileName);
        setLocalStorageItem(FILE_UPLOAD_KEY, JSON.stringify(updatedData));
    };




    const updateLinkedInUploadData = (fileName, updates) => {
        const textData = JSON.parse(getLocalStorageItem(TEXT_DATA) || '[]');

        if (Array.isArray(textData) && textData.length === 1 && textData[0].fileName === fileName) {
            const updatedFile = { ...textData[0], ...updates };
            setLocalStorageItem(TEXT_DATA, JSON.stringify([updatedFile]));
        }
    };


    const addToLinkedInUploadData = (newFile) => {
        setLocalStorageItem(TEXT_DATA, JSON.stringify([newFile]));
    };

    const removeFromLinkedInUploadData = () => {
        localStorage.removeItem(TEXT_DATA);
    };





    const updateStoredData = (fileName, updates) => {
        // Fetch stored files from localStorage
        const storedFiles = JSON.parse(localStorage.getItem(EXISTING_FILES_KEY)) || [];
        // Map through files and update the one matching fileName
        const updatedData = storedFiles.map((file) => {
            const isTargetFile = file.fileName === fileName;
            return isTargetFile ? { ...file, ...updates } : file;
        });
        // Save the updated data, sorted by lastUpdated
        saveData(updatedData, EXISTING_FILES_KEY);
    };


    function saveData(data, storageKey = EXISTING_FILES_KEY) {
        data.sort((a, b) => new Date(b.lastUpdated) - new Date(a.lastUpdated));
        localStorage.setItem(storageKey, JSON.stringify(data));
    }



    const removeFromStoredData = (fileName) => {
        const storedFiles = JSON.parse(localStorage.getItem(EXISTING_FILES_KEY)) || [];
        const updatedData = storedFiles.filter((file) => file.fileName !== fileName);
        localStorage.setItem(EXISTING_FILES_KEY, JSON.stringify(updatedData));
    };


    const refreshTableUI = async () => {
        setCustomTimeout(async () => {
            const fileData = await fetchFilesFromAPI();
            populateFileTable(fileData);
            populateExistingFilesTable();
            await loadLinkedInFromLocalStorage();
        }, 100);
    };


    const refreshLinkedInTabOnly = async () => {
        setCustomTimeout(async () => {
            await loadLinkedInFromLocalStorage();
        }, 100);
    };





    //For Existing file table

    const populateExistingFilesTable = (existingFileData) => {
        const existingFilesTable = document.getElementById("existingFilesTable").querySelector("tbody");
        const existingFilesHeading = document.getElementById("existingFilesHeading");
        const existingFilesTableContainer = document.getElementById("existingFilesTableContainer");
        const noExistingFiles = document.getElementById("no-existing-files");
        const refreshExistingFilesBtn = document.getElementById("refreshExistingFilesBtn");

        const storedFiles = existingFileData || JSON.parse(localStorage.getItem(EXISTING_FILES_KEY)) || [];
        existingFilesTable.innerHTML = ""; // Clear the existing rows

        if (!storedFiles.length) {
            //existingFilesHeading.style.display = "none";
            existingFilesTableContainer.style.display = "none";
            noExistingFiles.style.display = "flex";

            //refreshExistingFilesBtn.style.display = "none";
            return;
        }

        storedFiles.forEach((file) => {
            const fileName = file.fileName;
            const lastUpdated = file.lastUpdated || new Date().toISOString();
            const useThisFile = file.useThisFile || "false";
            addExistingTableRow(file.filePath, fileName, lastUpdated, useThisFile, false, file.metadatafilelink);
        });

        noExistingFiles.style.display = "none";
        existingFilesHeading.style.display = "block";
        existingFilesTableContainer.style.display = "block";
        refreshExistingFilesBtn.style.display = getCookie('refreshed') ? "none" : "inline-block";
    };


    const addExistingTableRow = (filePath, fileName, lastUpdated, useThisFile, prepend = false, metadatafilelink) => {
        const existingFilesTable = document.getElementById("existingFilesTable").querySelector("tbody");
        const tr = document.createElement("tr");

        // Remove column
        const tdRemove = document.createElement("td");
        tdRemove.classList.add("colRemove");
        const removeBtn = document.createElement("button");
        removeBtn.classList.add("fileUpload-tableRemoveBtn");
        removeBtn.textContent = "x";

        // Handler for removing the file
        const removeHandler = () => removeExistingFile(filePath, fileName, metadatafilelink, tr, checkboxHandler, false);
        addTemporaryListener(removeBtn, "click", removeHandler);
        tdRemove.appendChild(removeBtn);
        tr.appendChild(tdRemove);

        // Name column
        const tdName = document.createElement("td");
        tdName.classList.add("colName");
        const downloadLink = document.createElement("a");
        downloadLink.href = filePath;
        downloadLink.textContent = fileName;
        downloadLink.target = "_blank";
        downloadLink.rel = "noopener noreferrer";
        tdName.appendChild(downloadLink);
        tr.appendChild(tdName);

        // Last updated column
        const tdLastUpdated = document.createElement("td");
        tdLastUpdated.classList.add("colLastUpdated");
        tdLastUpdated.textContent = new Date(lastUpdated).toLocaleString();
        tr.appendChild(tdLastUpdated);

        // Use column with checkbox
        const tdUse = document.createElement("td");
        tdUse.classList.add("colUse", "fileUpload-radioCell");
        const checkbox = document.createElement("input");
        checkbox.type = "checkbox";
        checkbox.name = "useFile";
        checkbox.classList.add("custom-checkbox");
        checkbox.checked = useThisFile === "true";

        // Checkbox handler
        const checkboxHandler = () => {
            if (checkbox.checked) {
                const allCheckboxes = existingFilesTable.querySelectorAll("input[type='checkbox']");
                allCheckboxes.forEach((cb) => {
                    if (cb !== checkbox) cb.checked = false;
                });

                updateFileUsage(fileName, true, false);
            } else {
                updateFileUsage(fileName, false, false);
            }
        };

        addTemporaryListener(checkbox, "change", checkboxHandler);

        const label = document.createElement("span");
        label.classList.add("mobileLabel");
        label.textContent = getI18nExt("useThisFile");

        tdUse.appendChild(checkbox);
        tdUse.appendChild(document.createTextNode(" "));
        tdUse.appendChild(label);
        tr.appendChild(tdUse);

        // Add the row to the table
        if (prepend && existingFilesTable.firstChild) {
            existingFilesTable.insertBefore(tr, existingFilesTable.firstChild);
        } else {
            existingFilesTable.appendChild(tr);
        }

        ensureExistingTableVisibility();
    };



    const ensureExistingTableVisibility = () => {
        const existingFilesTable = document.getElementById("existingFilesTable").querySelector("tbody");
        const existingFilesHeading = document.getElementById("existingFilesHeading");
        const existingFilesTableContainer = document.getElementById("existingFilesTableContainer");
        const refreshExistingFilesBtn = document.getElementById("refreshExistingFilesBtn");
        const noExistingFiles = document.getElementById("no-existing-files");

        const hasRows = !!existingFilesTable.querySelector("tr");
        //existingFilesHeading.style.display = hasRows ? "block" : "none";
        noExistingFiles.style.display = hasRows ? "none" : "flex";
        existingFilesTableContainer.style.display = hasRows ? "block" : "none";
        //refreshExistingFilesBtn.style.display = hasRows ? "inline-block" : "none";
    };

    const removeExistingFile = (filePath, fileName, metadatafilelink, row, checkboxHandler, fromComputer) => {
        const fileToDelete = {
            path: filePath,
            filename: fileName, // Object shorthand
            metadatafilelink
        };

        Swal.fire({
            title: getI18nExt("modal.title.confirmDelete"),
            html: getI18nExt("modal.html.confirmDelete", { fileName }),
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: getI18nExt("modal.button.confirmDelete"),
            cancelButtonText: getI18nExt("modal.button.cancel"),
        }).then((result) => {
            if (result.isConfirmed) {
                showSpinner(); // Show spinner at the start of the operation

                // Use $.ajax for the delete operation
                $.ajax({
                    url: getApiUrl('deleteObjects', 'loginapi'),
                    method: 'POST',
                    contentType: 'application/json',
                    data: JSON.stringify({ vendor: vendor, folderUUID: folderUUID, files: [fileToDelete] }),
                    success: function (response) {
                        showGrowlMessage(getI18nExt("success.fileDeleted", { fileName }), "success");

                        // Remove file from local storage
                        createUpdateFilesEvents.deleteFile(fileName);
                        // Remove the row from the table
                        const checkbox = row.querySelector("input[type='checkbox']");
                        if (checkbox) {
                            checkbox.removeEventListener("change", checkboxHandler);
                            removeFromTemporaryListeners(checkbox, "change", checkboxHandler);
                        }
                        row.remove();
                    },
                    error: function (error) {
                        showGrowlMessage(getI18nExt("error.fileDeleteFailedGeneric"), "danger");
                        console.error(getI18nExt("error.fileDeleteFailedGeneric"), error);
                        updateHeaderFileName();
                        hideSpinner();
                    },
                    complete: function () {
                        hideSpinner(); // Always hide spinner after the operation completes
                        updateHeaderFileName();
                    },
                });
            }
        });
    };

    const uploadLinkedInProfileText = async (linkedinTextArea, useThisFromTextCheckbox, saveLinkedInButton) => {
        const text = linkedinTextArea.value.trim();
        const useThis = useThisFromTextCheckbox.checked ? "true" : "false";
        const linkedInUseThisFlag = getLocalStorageItem("linkedInUseThis") === "true";
        const isFirstUpload = !hasUseThisFileFlag();
        if (!text) {
            showGrowlMessage(getI18nExt("error.noLinkedInTextProvided"), "danger");
            return;
        }

        try {
            saveLinkedInButton.disabled = true;
            showSpinner();
            const compressedText = deflateAndEncode(text);
            const existingCompressed = getLocalStorageItem(LINKED_IN_KEY);

            // Check if already saved and no change
            if (existingCompressed === compressedText) {
                showGrowlMessage(getI18nExt("info.linkedInUsageNoChange"), "info");
                saveLinkedInButton.disabled = true;
                hideSpinner();
                return;
            }

            const hostname = window.location.hostname;
            const locale = getLanguage();
            const type = "linkedin";


            const requestData = {
                folderUUID,
                vendor,
                hostname,
                locale,
                type,
                useThisFile: isFirstUpload || linkedInUseThisFlag
            };





            // Convert encoded string back into Blob → File
            const blob = new Blob([compressedText], { type: "text/plain" });
            const file = new File([blob], LINKEDIN_FILENAME, {
                type: "text/plain",
                lastModified: Date.now()
            });



            // Reuse uploadUserFiles logic
            const formData = new FormData();
            formData.append("files", file);
            formData.append("requestData", new Blob([JSON.stringify(requestData)], { type: "application/json" }));

            const response = await fetch(getApiUrl('uploaduserfiles', 'loginapi'), {
                method: "POST",
                headers: {
                    "X-CSRF-Token": "test-csrf-token"
                },
                body: formData
            });

            if (!response.ok) {
                throw new Error(getI18nExt("error.uploadFailed", { statusText: response.statusText }));
            }

            const result = await response.json();

            for (const fileResult of result) {
                console.log("processing fileResult");
                if (fileResult.success) {

                    const filePath = fileResult.filePath || "<unknown>";
                    const fileName = filePath.split("/").pop();
                    const lastUpdated = fileResult.lastUpdated || new Date().toISOString();
                    const useThisFile = fileResult.useThisFile === "true" ? "true" : "false";
                    const type = fileResult.type;

                    if (useThisFile === "true") {
                        const modal = document.getElementById("fileUploadModal");
                        const allCheckboxes = modal.querySelectorAll("input[type='checkbox']");
                        allCheckboxes.forEach((cb) => (cb.checked = false));
                        if (useThisFromTextCheckbox) {
                            useThisFromTextCheckbox.checked = true;
                        }
                    }

                    //this mean that we need to explicitly remove check for others
                    addToLinkedInUploadData({ filePath, fileName, lastUpdated, useThisFile, type });
                    setLocalStorageItem(LINKED_IN_KEY, compressedText);
                    if (useThisFromTextCheckbox.checked) {
                        showGrowlMessage(getI18n("info.linkedInContentSaved"), "success");
                    } else {
                        showGrowlMessage(getI18n("info.linkedInContentSavedCheckbox"), "success");
                    }
                } else {
                    showGrowlMessage(
                        getI18nExt("error.uploadSingleFileFailed", { message: fileResult.message }),
                        "danger"
                    );
                }
            }

            //Here checking if checkbox is checked when the save is clicked on linkedInprofileText
            //if the checkbox is checked it is checked if linkedFile is already selected and this is not first load because in first load there are no other checkbox checked
            //In Fileupload and Existing table so we don't need to remove any flags in fileupload and existing.
            //This code is when user cliked the use this checkbox on linkedIn profile text and then click save
            if (useThis === "true" && !linkedInUseThisFlag && !isFirstUpload) {
                console.log('updateFileUsage is called from uploadLinkedInProfileText');
                await updateFileUsage(LINKEDIN_FILENAME, useThis, false, true);
            }

        } catch (error) {
            console.error("LinkedIn profile upload error:", error);
            showGrowlMessage(getI18nExt("error.genericUploadFailure"), "danger");
            refreshLinkedInTabOnly();
        } finally {
            saveLinkedInButton.disabled = false;
            updateHeaderFileName();
            hideSpinner();
        }
    };




    // Function to deflate and encode the content
    function deflateAndEncode(content) {
        // Use pako to deflate the string content
        const deflatedContent = pako.deflate(content, { to: 'string' });

        // Encode the deflated content with btoa
        return btoa(deflatedContent);
    }

    // Function to safely decode Base64 and inflate using Pako
    function decodeAndInflate(encodedContent) {
        try {
            if (!encodedContent || typeof encodedContent !== "string") {
                throw new Error("Invalid Base64 input: Empty or non-string value.");
            }

            // Normalize Base64 padding
            const normalizedBase64 = encodedContent.replace(/-/g, "+").replace(/_/g, "/");

            // Decode Base64 (Works for both browser & Node.js)
            const binaryData = typeof window !== "undefined"
                ? Uint8Array.from(atob(normalizedBase64), c => c.charCodeAt(0))
                : Uint8Array.from(Buffer.from(normalizedBase64, "base64"));

            // Inflate using Pako
            const inflatedContent = new TextDecoder().decode(pako.inflate(binaryData));

            return inflatedContent;
        } catch (error) {
            console.error("❌ Error decoding and inflating content:", error);
            throw new Error("Failed to decode and inflate content.");
        }
    }




    return { init, unloadAll, updateBadgeIcons };
})();

export default FileUploadEvents;

